

"use client";
import { useEffect, useMemo, useState } from "react";

import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Typography,
  CircularProgress
} from "@mui/material";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import TableConfigForm from "./TableConfigForm";
import { MAIN_URL } from "../../Configurations/Urls";
import axios from "axios";

export default function MultiTableConfig() {
  const { userData } = useAuthStore();
  const org = userData?.organization;
    const tables = useMemo(() => [
  
      {
        id: "employees",
        tablename: "Employees",
        tableheading: "employee-list",
        apiFieldsConfig:    `${MAIN_URL}/api/organizations/${org?.organization_id}/employee?mode=2`,
        datagridKeyProp: `Employees_grid_${org?.organization_id}`,
      },

      {
        id: "employee_exit",
        tablename: "Employee Exits",
        tableheading: "employee_exit",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-exit?mode=1`,
        datagridKeyProp: `employee_exits_grid_${org?.organization_id}`,
      },
     
      {
        id: "employment_records",
        tablename: "Employee Records",
        tableheading: "employment_records",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-records?mode=1`,
        datagridKeyProp: `employee_employment_records_grid_${org?.organization_id}`,
      },
      {
        id: "employee_functional_role",
        tablename: "Employee Functional Roles",
        tableheading: "employee_functional_roles",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/emp-func-role?mode=1`,
        datagridKeyProp: `employee_functional_roles_grid_${org?.organization_id}`,
      },
  
      {
        id: "employment_stages",
        tablename: "Employment Stages",
        tableheading: "employment_stages",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employment-stages?mode=1`,
        datagridKeyProp: `organization_employment_stages_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_document_types",
        tablename: "Document Types",
        tableheading: "employee_document_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-document-type?mode=1`,
        datagridKeyProp: `Document Types_grid_${org?.organization_id}`,
      },
  
      {
        id: "documents",
        tablename: "Employee Documents",
        tableheading: "documents",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-document?mode=1`,
        datagridKeyProp: `Employee Documents_grid_${org?.organization_id}`,
      },
  
      {
        id: "work_shifts",
        tablename: "Work Shifts",
        tableheading: "work_shifts",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift?mode=1`,
        datagridKeyProp: `organization_work_shifts_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_shift_assignments",
        tablename: "Employee WorkShift Assignments",
        tableheading: "employee_shift_assignments",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-assignment?mode=1`,
        datagridKeyProp: `employee_work_shift_assignments_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_shift_rotation_pattern",
        tablename: "Employees Shift Rotation Pattern",
        tableheading: "employee_shift_rotation_pattern",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-rotation-pattern?mode=1`,
        datagridKeyProp: `organization_work_shift_rotation_patterns_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_shift_rotation_days",
        tablename: "Employees Rotation Days",
        tableheading: "employee_shift_rotation_days",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-rotation-days?mode=1`,
        datagridKeyProp: `organization_work_shift_rotation_days_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_shift_rotation_assignments",
        tablename: "Employees Rotation Assignments",
        tableheading: "employee_shift_rotation_assignments",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-rotation-assignment?mode=1`,
        datagridKeyProp:`employee_work_shift_rotation_assignments_grid_${org?.organization_id}`,
      },
  
      {
        id: "attendande_time_logs",
        tablename: "Attendance Time Logs",
        tableheading: "attendande_time_logs",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-time-logs?mode=1`,
        datagridKeyProp: `organization_person_attendance_timelogs_grid_${org?.organization_id}`,
      },

      {
        id: "employee_attendance_records",
        tablename: "Attendance Records",
        tableheading: "employee_attendance_records",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-employee-record?mode=1`,
        datagridKeyProp: `organization_person_attendance_records_grid_${org?.organization_id}`,
      },

    
  
      {
        id: "holiday_calender",
        tablename: "Holiday Calendar",
        tableheading: "holiday_calender",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/holiday-calendar?mode=1`,
        datagridKeyProp: `organization_holiday_calendars_${org?.organization_id}`,
      },
  
      {
        id: "employee_leaves",
        tablename: "Employee Leaves",
        tableheading: "employee-leaves",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave?mode=1`,
        datagridKeyProp: `employee_leaves_grid_${org?.organization_id}`,
      },
  
      {
        id: "employee_entitlements",
        tablename: "Employees Leave Entitlement",
        tableheading: "employee_entitlements",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-entitlements?mode=1`,
        datagridKeyProp: `organization_leave_entitlements_grid_${org?.organization_id}`,
      },
  
      {
        id: "leave_summary",
        tablename: "Leave Summary Report",
        tableheading: "leave_summary",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-monthlyleave-summary?mode=1`,
        datagridKeyProp: `organization_person_leave_monthly_summaries_grid_${org?.organization_id}`,
      },

      
      {
        id: "organization_person_leave_monthly_summaries",
        tablename: "Leave Type Summary Report",
        tableheading: "leave_type_summary",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave-type-monthly-summary?mode=2`,
        datagridKeyProp: `organization_person_leave_type_monthly_summaries_grid_${org?.organization_id}`,
      },

      {
        id: "employee_leave_category_summary",
        tablename: "Leave Category Monthly Summary Report",
        tableheading: "leave_category_summary",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave-category-monthly-summary?mode=2`,
        datagridKeyProp: `organization_person_leave_category_monthly_summaries_${org?.organization_id}`,
      },


      // {
      //   id: "leave_category_summary_report",
      //   tablename: "Employee Leave Category Summary Report",
      //   tableheading: "leave_category_summary_report",
      //   apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave-category-monthly-summary?mode=1`,
      //   datagridKeyProp: `employee_leave_category_monthly_summaries_grid_${org?.organization_id}`,
      // },
  



  
      {
        id: "leave_balance_report",
        tablename: "Employee Leave Balance Report",
        tableheading: "leave_balance_report",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/leave-balances/taken?mode=1`,
        datagridKeyProp: `employee_leave_balances_grid_${org?.organization_id}`,
      },
  
  
      {
        id: "increment_types",
        tablename: "Increment Types",
        tableheading: "increment_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/increment-type?mode=1`,
        datagridKeyProp: `Increment Types_grid_${org?.organization_id}`,
      },
  
      {
        id: "increments",
        tablename: "Employee Increments",
        tableheading: "employee_increments",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/increment?mode=1`,
        datagridKeyProp: `employee_increments_grid_${org?.organization_id}`,
      },

    
      {
        id: "departments",
        tablename: "Departments",
        tableheading: "Departments",
        apiFieldsConfig:`${MAIN_URL}/api/organizations/${org?.organization_id}/department?mode=1`,
        datagridKeyProp: `departments_grid_${org?.organization_id}`,
      },
  
      {
        id: "locations",
        tablename: "Locations",
        tableheading: "locations",
        apiFieldsConfig:`${MAIN_URL}/api/organizations/${org?.organization_id}/location?mode=1`,
        datagridKeyProp: `Locations_grid_${org?.organization_id}`,
      },
  
      {
        id: "organization_units",
        tablename: "Organization Units",
        tableheading: "organization_units",
        apiFieldsConfig:`${MAIN_URL}/api/organizations/${org?.organization_id}/units?mode=1`,
        datagridKeyProp: `organization_units_grid_${org?.organization_id}`,
      },
  
      {
        id: "designation",
        tablename: "Designation",
        tableheading: "Designation",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/designation?mode=1`,
        datagridKeyProp: `Designations_grid_${org?.organization_id}`,
      },
  
      {
        id: "registration",
        tablename: "Registrations",
        tableheading: "registration",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/business-registration?mode=1`,
        datagridKeyProp: `organization_business_registrations_grid_${org?.organization_id}`,
      },

      {
        id: "attendance_deviation_reason",
        tablename: "Attendance Deviation Reason",
        tableheading: "attendance_deviation",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-deviation-reason?mode=1`,
        datagridKeyProp: `organization_attendance_deviation_reasons_grid_${org?.organization_id}`,
      },



  
      {
        id: "attendance_status_types",
        tablename: "Attendance Status Type",
        tableheading: "attendance_status_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-status-type?mode=1`,
        datagridKeyProp: `Attendance Status Type_grid_${org?.organization_id}`,
      },
  
      {
        id: "attendance_break_types",
        tablename: "Attendance Break Types",
        tableheading: "attendance_break_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-break-type?mode=1`,
        datagridKeyProp: `Attendance Break Types_grid_${org?.organization_id}`,
      },
  
      {
        id: "attendance_sources",
        tablename: "Attendance Source",
        tableheading: "attendance_sources",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-source?mode=1`,
        datagridKeyProp: `organization_attendance_sources_grid_${org?.organization_id}`,
      },
  
      {
        id: "attendance_breaks",
        tablename: "Attendance Break",
        tableheading: "attendance_breaks",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-breaks?mode=1`,
        datagridKeyProp: `organization_attendance_breaks_grid_${org?.organization_id}`,
      },

      {
        id: "organization_work_shift_breaks",
        tablename: "Work Shift Breaks",
        tableheading: "organization_work_shift_breaks",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-breaks?mode=1`,
        datagridKeyProp: `organization_work_shift_breaks_grid_${org?.organization_id}`,
      },
  
   
  
      {
        id: "leave_policies",
        tablename: "Organization Leave Policy",
        tableheading: "leave_policies",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/leave-policy?mode=1`,
        datagridKeyProp: `organization_leave_policies_grid_${org?.organization_id}`,
      },
  
      {
        id: "organization_functional_roles",
        tablename: "Organization Functional Roles",
        tableheading: "organization_functional_roles",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/func-role?mode=1`,
        datagridKeyProp: `organization_functional_roles_grid_${org?.organization_id}`,
      },
  
      {
        id: "functional_role_specialization",
        tablename: "Functional Role Specialization",
        tableheading: "functional_role_specialization",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/func-role-spec?mode=1`,
        datagridKeyProp: `organization_functional_role_specializations_grid_${org?.organization_id}`,
      },

      {
        id: "internship_types",
        tablename: "Internship Types",
        tableheading: "internship_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/internship-type?mode=1`,
        datagridKeyProp: `Internship Types_grid_${org?.organization_id}`,
      },
  
      {
        id: "internship_status",
        tablename: "Internship Status",
        tableheading: "internship_status",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/internship-status?mode=1`,
        datagridKeyProp: `organization_internship_statuses_grid_${org?.organization_id}`,
      },

      {
        id: "internship_stages",
        tablename: "Internship Stages",
        tableheading: "internship_stages",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/internship-stages?mode=1`,
        datagridKeyProp: `organization_internship_stages_grid_${org?.organization_id}`,
      },
  
      {
        id: "interns",
        tablename: "Interns",
        tableheading: "interns",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/interns?mode=1`,
        datagridKeyProp: `Interns_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_exit",
        tablename: "Intern Exit",
        tableheading: "intern_exit",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-exit?mode=1`,
        datagridKeyProp: `intern_exit_records_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_functional_roles",
        tablename: "Intern Functional Roles",
        tableheading: "intern_functional_roles",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-func-role?mode=1`,
        datagridKeyProp: `intern_functional_roles_${org?.organization_id}`,
      },
  
      {
        id: "intern_leaves",
        tablename: "Intern Leaves",
        tableheading: "intern_leaves",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leaves?mode=1`,
        datagridKeyProp: `intern_leaves_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_document_types",
        tablename: "Intern Document Types",
        tableheading: "intern_document_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-document-type?mode=1`,
        datagridKeyProp: `Intern Document Types_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_stipend",
        tablename: "Intern Stipend",
        tableheading: "intern_stipend",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-stipend?mode=1`,
        datagridKeyProp: `intern_stipends_grid_${org?.organization_id}`,
      },
  
      {
        id: "intern_time_logs",
        tablename: "Intern Attendance TimeLogs",
        tableheading: "intern_time_logs",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-time-logs?mode=1`,
        datagridKeyProp: `intern_attendance_timelogs_grid_${org?.organization_id}`,
      },

      {
        id: "intern_attendance_records",
        tablename: "Intern Attendance Records",
        tableheading: "intern_attendance_records",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-attendance-record?mode=1`,
        datagridKeyProp: `intern_attendance_records_grid_${org?.organization_id}`,
      },

      {
        id: "intern_certificate",
        tablename: "Intern Certificates",
        tableheading: "intern_certificate",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-certificate?mode=1`,
        datagridKeyProp: `intern_certificates_grid_${org?.organization_id}`,
      },
      {
        id: "intern_leave_monthly_summaries",
        tablename: "Intern Leave Monthly Summary",
        tableheading: "intern_leave_monthly_summaries",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-summaries?mode=1`,
        datagridKeyProp: `intern_leave_monthly_summaries_grid_${org?.organization_id}`,
      },


      {
        id: "intern_leave_type_monthly_summaries",
        tablename: "Intern Leave Type Monthly Summary",
        tableheading: "intern_leave_type_monthly_summaries",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-type-monthly-summary?mode=1`,
        datagridKeyProp: `intern_leave_type_monthly_summaries_grid_${org?.organization_id}`,
      },

      {
        id: "intern_leave_category_monthly_summaries",
        tablename: "Intern Leave Category Monthly Summary",
        tableheading: "intern_leave_category_monthly_summaries",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-category-monthly-summary?mode=1`,
        datagridKeyProp: `intern_leave_category_monthly_summaries_grid_${org?.organization_id}`,
      },

      {
        id: "intern_leave_balances",
        tablename: "Intern Leave balances",
        tableheading: "intern_leave_balances",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-balances?mode=1`,
        datagridKeyProp: `intern_leave_balances_grid_${org?.organization_id}`,
      },

      {
        id: "user_role",
        tablename: "User Roles",
        tableheading: "user_role",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/userrole?mode=1`,
        datagridKeyProp: `User Roles_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_cycle",
        tablename: "Payroll Cycle",
        tableheading: "payroll_cycle",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-cycle?mode=1`,
        datagridKeyProp: `organization_payroll_cycles_grid_5${org?.organization_id}`,
      },
      
      {
        id: "payroll_component_types",
        tablename: "Payroll Component Types",
        tableheading: "payroll_component_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-component-type?mode=1`,
        datagridKeyProp: `Payroll Component Types_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_components",
        tablename: "Payroll Components",
        tableheading: "payroll_components",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-component?mode=1`,
        datagridKeyProp: `Payroll Components_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_component_slabs",
        tablename: "Payroll Component Slabs",
        tableheading: "payroll_component_slabs",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-component-slab?mode=1`,
        datagridKeyProp: `Payroll Component Slabs_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_periods",
        tablename: "Payroll Periods",
        tableheading: "payroll_periods",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-period?mode=1`,
        datagridKeyProp: `Payroll Periods_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_runs",
        tablename: "Payroll Runs",
        tableheading: "payroll_runs",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-run?mode=1`,
        datagridKeyProp: `Payroll Runs_grid_${org?.organization_id}`,
      },

      {
        id: "employee_salary_structures",
        tablename: "Employee Salary Structures",
        tableheading: "employee_salary_structures",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-salary-structure?mode=1`,
        datagridKeyProp: `organization_payroll_employee_salary_structures_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_advances",
        tablename: "Payroll Advances",
        tableheading: "payroll_advances",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-advance?mode=1`,
        datagridKeyProp: `Payroll Advances_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_securities",
        tablename: "Payroll Securities",
        tableheading: "payroll_securities",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-security?mode=1`,
        datagridKeyProp: `Payroll Securities_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_security_transactions",
        tablename: "Payroll Security Transactions",
        tableheading: "payroll_security_transactions",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-security-transaction?mode=1`,
        datagridKeyProp: `Payroll Security Transactions_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_loans",
        tablename: "Payroll Loans",
        tableheading: "payroll_loans",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-loan?mode=1`,
        datagridKeyProp: `Payroll Loans_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_loan_types",
        tablename: "Payroll Loan Types",
        tableheading: "payroll_loan_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-loan-type?mode=1`,
        datagridKeyProp: `Payroll Loan Types_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_loan_transactions",
        tablename: "Payroll Loan Transactions",
        tableheading: "payroll_loan_transactions",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-loan-transaction?mode=1`,
        datagridKeyProp: `Payroll Loan Transactions_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_reimbursements",
        tablename: "Payroll Reimbursements",
        tableheading: "payroll_reimbursements",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-reimbursement?mode=1`,
        datagridKeyProp: `Payroll Reimbursements_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_reimbursement_types",
        tablename: "Payroll Reimbursement Types",
        tableheading: "payroll_reimbursement_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-reimbursement-type?mode=1`,
        datagridKeyProp: `Payroll Reimbursement Types_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_adjustments",
        tablename: "Payroll Adjustments",
        tableheading: "payroll_adjustments",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-adjustment?mode=1`,
        datagridKeyProp: `Payroll Adjustments_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_adjustment_types",
        tablename: "Payroll Adjustment Types",
        tableheading: "payroll_adjustment_types",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-adjustment-type?mode=1`,
        datagridKeyProp: `Payroll Adjustment Types_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_journal_entries",
        tablename: "Payroll Journal Entries",
        tableheading: "payroll_journal_entries",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-journal-entries?mode=1`,
        datagridKeyProp: `Payroll Journal Entries_grid_${org?.organization_id}`,
      },

      {
        id: "organization_payroll_run_employees",
        tablename: "Payroll Run Employees",
        tableheading: "payroll_run_employees",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-employee-runs?mode=1`,
        datagridKeyProp: `Payroll Run Employees_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_run_employee_components",
        tablename: "Payroll Run Employee Components",
        tableheading: "payroll_run_employee_components",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-run-employee-component?mode=1`,
        datagridKeyProp: `Payroll Run Employee Components_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_salary_structure_components",
        tablename: "Payroll Salary Structure Components",
        tableheading: "payroll_salary_structure_components",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll/salary-component?mode=1`,
        datagridKeyProp: `Payroll Salary Structure Components_grid_${org?.organization_id}`,
      },

      {
        id: "payroll_account_mappings",
        tablename: "Payroll Account Mappings",
        tableheading: "payroll_account_mappings",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-account-mapping?mode=1`,
        datagridKeyProp: `Payroll Account Mappings_grid_${org?.organization_id}`,
      },

      {
        id: "employee_payslips",
        tablename: "Employee Payslips",
        tableheading: "employee_payslips",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-payslip?mode=1`,
        datagridKeyProp: `Employee Payslips_grid_${org?.organization_id}`,
      },

      {
        id: "employee_payslip_components",
        tablename: "Employee Payslip Components",
        tableheading: "employee_payslip_components",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-payslip-component?mode=1`,
        datagridKeyProp: `Employee Payslip Components_grid_${org?.organization_id}`,
      },

      {
        id: "employee_payslip_payments",
        tablename: "Employee Payslip Payments",
        tableheading: "employee_payslip_payments",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-payslip-payment?mode=1`,
        datagridKeyProp: `Employee Payslip Payments_grid_${org?.organization_id}`,
      },

      {
        id: "users",
        tablename: "Users",
        tableheading: "users",
        apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/user?mode=1`,
        datagridKeyProp: `Users_grid_${org?.organization_id}`,
      },
       
      // Add more tables as needed
    ], [org?.organization_id]);

  



  const [activeTableId, setActiveTableId] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [autoColumns, setAutoColumns] = useState([]);

  // Set initial active table
  useEffect(() => {
    if (tables?.length > 0 && !activeTableId) {
      setActiveTableId(tables[0].id);
    }
  }, [tables, activeTableId]);

  // Get current active table object
  const activeTable = useMemo(() => {
    return tables.find(t => t.id === activeTableId);
  }, [tables, activeTableId]);

  // Fetch data when active table changes
  // useEffect(() => {
  //   if (!activeTable?.apiFieldsConfig) return;

  //   setLoading(true);
  //   setData([]);
   
  //   fetch(activeTable.apiFieldsConfig)
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }
  //       return response.json();
  //     })
  //     .then((result) => {
  //       // Handle different response formats
  //       const dataArray = result.data || result.rows || result || [];
  //       setData(Array.isArray(dataArray) ? dataArray : []);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Fetch error:", error);
  //       setData([]);
  //       setLoading(false);
  //     });
  // }, [activeTable]);

  useEffect(() => {
  if (!activeTable?.apiFieldsConfig) return;
  // Avoid requesting when org not loaded (would hit .../undefined/... and 404)
  if (activeTable.apiFieldsConfig.includes("undefined")) return;

  setLoading(true);
  setData([]);

  const token = localStorage.getItem("token");

  axios
    .get(activeTable.apiFieldsConfig, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      const result = response.data;
      // Handle different possible structures
      const dataArray = result.data || result.rows || result || [];
      setData(Array.isArray(dataArray) ? dataArray : []);
    })
    .catch((error) => {
      console.error("Axios error:", error);
      setData([]);
    })
    .finally(() => {
      setLoading(false);
    });
}, [activeTable]);

 
  // Handle dropdown change
  const handleTableChange = (event) => {
    setActiveTableId(event.target.value);
  };

  return (
    <Box>
        <FormControl fullWidth sx={{ mt: 2, mb: 3 }}>
          <InputLabel id="table-datagrid-label">Select DataGrid</InputLabel>
          <Select
            labelId="table-datagrid-label"
            id="table-datagrid"
            value={activeTableId}
            label="Select DataGrid"
            onChange={handleTableChange}
          >
            {tables.map((table) => (
              <MenuItem key={table.id} value={table.id}>
                {table.tablename}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
            <CircularProgress />
            <Typography sx={{ ml: 2 }}>Loading {activeTable?.tablename}...</Typography>
          </Box>
        )}
       
        {!loading && activeTable && (
          <TableConfigForm
            tablename={activeTable.tablename}
            tableheading={activeTable.tableheading}
            apiFieldsConfig={activeTable.apiFieldsConfig}
            datagridKeyProp={activeTable.datagridKeyProp}
            data={data}
            autoColumns={autoColumns}
          />
        )}
    </Box>
  );
}

